"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Separator = function Separator(_ref) {
  var paddingSize = _ref.paddingSize;
  return _react.default.createElement(_styles.Block, {
    paddingSize: paddingSize
  });
};

exports.Separator = Separator;